import DatePicker, { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import FieldValidationError from "./FieldValidationError";

// O react-datepicker nasce em inglês: sem o locale, o calendário abre com "September" e
// "Su Mo Tu". Registrar aqui, no componente compartilhado, resolve de uma vez todos os
// formulários que usam InputDate.
registerLocale("pt-BR", ptBR);

const formatDateInput = (value) => {
    if (!value || typeof value !== 'string') return '';

    const numbers = value.replace(/\D/g, '');
    let formatted = '';

    if (numbers.length <= 2) {
        formatted = numbers;
    } else if (numbers.length <= 4) {
        formatted = `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
    } else {
        formatted = `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
    }

    return formatted;
};

/** Máscara do campo de mês: só mm/aaaa. */
const formatMonthInput = (value) => {
    if (!value || typeof value !== 'string') return '';

    const numbers = value.replace(/\D/g, '');
    return numbers.length <= 2 ? numbers : `${numbers.slice(0, 2)}/${numbers.slice(2, 6)}`;
};

/**
 * @param {boolean} monthOnly - Escolhe só mês e ano (ex.: vigência de bonificação). O valor
 *        devolvido continua sendo um Date, no dia 1 do mês escolhido.
 */
const InputDate = (props) => {
    const { popperClassName = '', wrapperClassName = '', monthOnly = false, ...datePickerProps } = props;

    const handleRawChange = (e) => {
        e.target.value = monthOnly ? formatMonthInput(e.target.value) : formatDateInput(e.target.value);
    };

    return (
        <>
            <DatePicker
                className="form-control"
                // Antes do spread: a tela que precisar de outro idioma ou de outro texto de
                // apoio ainda pode sobrescrever.
                locale="pt-BR"
                placeholderText={monthOnly ? "mm/aaaa" : "dd/mm/aaaa"}
                {...datePickerProps}
                showMonthYearPicker={monthOnly}
                dateFormat={monthOnly ? "MM/yyyy" : "dd/MM/yyyy"}
                onChangeRaw={handleRawChange}
                // O wrapper do react-datepicker é inline-block por padrão, e o campo saía
                // mais estreito que os demais controles da mesma linha.
                wrapperClassName={`colmeia-datepicker-wrapper ${wrapperClassName}`.trim()}
                popperClassName={`colmeia-datepicker-popper ${popperClassName}`.trim()}
            />
            <FieldValidationError error={props.error} />
        </>
    );
}

export default InputDate;
